import React from "react";
import styled from "@emotion/styled";
import { Alert } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const StyledAlert = styled(Alert)`
  margin-bottom: 0;
  border-radius: 0;
  width: 100%;
  z-index: 990;
  position: relative;
  padding: 12px 16px;
  max-width: none;
  left: 0;
  right: 0;
  box-sizing: border-box;

  .ant-alert-content {
    flex: 1;
  }

  .ant-alert-message {
    font-weight: 600;
    font-size: 15px;
  }

  .ant-alert-description {
    font-size: 14px;
    line-height: 1.5;
  }
`;

export const PortCongestionBanner: React.FC = () => {
  const { i18n } = useTranslation();

  // Get content based on current language
  const getContent = () => {
    // Default to Dutch message
    if (i18n.language === "en") {
      return {
        title: "Notice: Congestion in Rotterdam port may cause delays",
        description:
          "Due to significant congestion at container terminals in the Port of Rotterdam, certain shipping companies are considering skipping the port. This may mean your shipments could be delayed or redirected through a different port. We are monitoring the situation for you and will keep you updated.",
      };
    } else if (i18n.language === "zh") {
      return {
        title: "注意：鹿特丹港口拥堵可能导致延误",
        description:
          "由于鹿特丹港集装箱码头的严重拥堵，某些航运公司正在考虑跳过该港口。这可能意味着您的货物可能会延误或通过其他港口转运。我们正在为您监控情况，并会随时通知您最新进展。",
      };
    } else {
      // Dutch (default)
      return {
        title: "Let op: drukte in haven Rotterdam kan vertraging opleveren",
        description:
          "Door flinke drukte op de containerterminals in de haven van Rotterdam overwegen bepaalde rederijen de haven over te slaan. Dit kan betekenen dat jouw zendingen vertraging oplopen of via een andere haven worden omgeleid. We houden de situatie voor je in de gaten en houden je op de hoogte.",
      };
    }
  };

  const content = getContent();

  return (
    <StyledAlert
      type="warning"
      message={content.title}
      description={content.description}
      banner
      showIcon
      icon={<WarningOutlined />}
      closeIcon={false}
    />
  );
};
